import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskAgentThinking_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from 'src/entities/ActivityLog/Helpers/ActivityLogBase';
import { useAiAgentLabel } from 'src/entities/ActivityLog/Helpers/useAiAgentLabel';

import useIsAiTaskEnabled from 'src/hooks/useIsAiTaskEnabled';

interface Fragments {
  activityLog: ActivityLogTaskAgentThinking_ActivityLogFragment;
}

const ActivityLogTaskAgentThinking: FCWithFragments<Fragments> = ({ activityLog }) => {
  const aiTaskEnabled = useIsAiTaskEnabled();
  const aiAgentLabel = useAiAgentLabel();
  if (!aiTaskEnabled) {
    return null;
  }

  return <ActivityLogBase activityLog={activityLog} actionLabel={`${aiAgentLabel} is thinking`} />;
};

ActivityLogTaskAgentThinking.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskAgentThinking_activityLog on ActivityLog {
      id
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskAgentThinking;
